import { toast } from 'react-toastify'

export const toastSuccess = (message: string) => {
  const toastId = message.replace(/[^a-zA-Z0-9]/g, '-')
  if (toast.isActive(toastId)) {
    return
  }
  toast.success(message, {
    toastId: toastId,
    position: 'top-center',
    autoClose: 3500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
  })
}

export const toastError = (message: string) => {
  const toastId = message.replace(/[^a-zA-Z0-9]/g, '-')
  if (toast.isActive(toastId)) {
    return
  }
  toast.error(message, {
    toastId: toastId,
    position: 'top-center',
    autoClose: 3500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
  })
}

export const toastInfo = (message: string) => {
  const toastId = message.replace(/[^a-zA-Z0-9]/g, '-')
  if (toast.isActive(toastId)) {
    return
  }
  toast.dismiss()
  toast.info(message, {
    toastId: toastId,
    position: 'top-center',
    autoClose: 3500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
  })
}
